import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import inputStyle from '@/components/Shares/Input.module.css';
import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Flex, Input, SimpleGrid, Stack, Text, rem } from '@mantine/core';
export const ProfileCompleteForm: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    successes,
    setVerifyStatus
  } = useVerifyProfile();
  const handleSubmit = () => {
    successes.add(PROFILE_STATUS.COMPLETE);
    setVerifyStatus(PROFILE_STATUS.VERIFICATION);
  };
  return <Flex direction="column" align="center" justify={{
    base: 'center',
    lg: 'start'
  }} h="100%" p={{
    base: 24,
    sm: 0
  }} mt={{
    lg: 40
  }}>
      <Stack maw={{
      sm: 369,
      lg: '100%'
    }}>
        <Text fz={rem(25)} className={gunterzBold.className} ta="center" style={{
        textWrap: 'nowrap'
      }}>
          {i18n._('COMPLETE PROFILE')}
        </Text>

        <form>
          <Stack gap={10}>
            <Input classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('FIRST NAME')} />
            <Input classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('LAST NAME')} />
            <Input classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('DATE OF BIRTH')} />
            <Input classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('OCUPATION')} />
            <Input classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('RESIDENTIAL ADDRESS')} />
            <Input classNames={{
            input: inputStyle.input_style_2
          }} placeholder={i18n._('COUNTRY')} />
            <SimpleGrid cols={2} spacing={10}>
              <Input classNames={{
              input: inputStyle.input_style_2
            }} placeholder={i18n._('STATE')} />
              <Input classNames={{
              input: inputStyle.input_style_2
            }} placeholder={i18n._('ZIP CODE')} />
            </SimpleGrid>
          </Stack>
        </form>

        <Button w={220} h={46} ml="auto" mt={{
        base: 25,
        lg: 30
      }} tt="uppercase" fw={700} fz={rem(13)} onClick={handleSubmit} leftSection={<Icons className="icon-pr-line-log-in" fontSize={25} />} classNames={btnStyle}>
          {i18n._('Save & Continue')}
        </Button>
      </Stack>
    </Flex>;
};